import { all, call } from 'redux-saga/effects';
import snackbar from './snackbarHandlers';
import sagas from './sagas';

export default function* dnsSagas() {
	yield all([call(snackbar), call(sagas)]);
}
